import React from "react";
import TutoringInbox from "../../../../componrnt/pages/Tutoring/TutoringInbox";
import * as api from "../../../api/Tutoring";

// Branch scope. Adds branch_id to every call so backend can enforce
// ownership.
const getBranchId = () => localStorage.getItem("b_id");
const getUserId = () => {
  try {
    return JSON.parse(localStorage.getItem("userData"))?.data?.id;
  } catch {
    return null;
  }
};

const branchApi = {
  listThreads: (params) =>
    api.tutoring_threads({ branch_id: getBranchId(), ...params }),
  getThread: (id) => api.tutoring_thread(id, getBranchId()),
  reply: ({ thread_id, body, attachment_url }) =>
    api.tutoring_reply({
      thread_id, body, attachment_url,
      branch_id: getBranchId(),
      user_id: getUserId(),
    }),
  setStatus: (id, status) =>
    api.tutoring_thread_status(id, { status, branch_id: getBranchId() }),
  uploadAttachment: (file) => api.upload_attachment(file),
};

const BranchTutoring = () => <TutoringInbox api={branchApi} scope="branch" />;

export default BranchTutoring;
